import { AssetBudget, LocationType } from './asset';
import { GeoJSONPoint } from './geojson';
import { PolicyAction, PolicyGrant } from './policy';
import {
  AttributeGroupsItem,
  AttributesCollection,
  ElementGroupsItem,
} from './schema';

// Shapes for the REST inventory endpoints (`/api/v1/inventory/assets`) and the
// redux `inventory` slice behind the inventory portal. Still load-bearing for
// the inventory and transfer trees, the create-work modal and the PCI form
// fields. The GraphQL asset shapes are the separate family in `./asset` — note
// that `AssetDetail` there overlaps this heavily but is not interchangeable.

export interface LastWorkOrderType {
  id?: string;
  name?: string;
  updatedDate?: number;
}

export interface InventoryAssetDetailType {
  id?: string;
  name?: string;
  externalId?: string;
  parentCategoryId?: string;
  categoryId?: string;
  parentAssetId?: string;
  createdDate?: number;
  updatedDate?: number;
  changeType?: string;
  attributes?: AttributesCollection;
  schemaId?: string;
  assetType?: string;
  markerId?: number;
  colorId?: number;
  elementDetail?: any;
  isMaterial?: boolean;
  budget?: AssetBudget;
  location?: GeoJSONPoint;
  locationType?: LocationType | null;
  attributeGroups?: AttributeGroupsItem[];
  elementGroups?: ElementGroupsItem[];
  lastWorkOrder?: LastWorkOrderType;
  address?: string;
  cursor?: {
    total: number;
    index: number;
    next: string;
    previous: string;
  };
  mainPhotoFileId?: string;
  grants?: PolicyGrant[];
  actions?: PolicyAction[];
  inactive?: boolean;
  archived?: boolean;
  includeChangesBefore?: number;
}

export interface ColumnItem {
  name?: string;
  fieldName?: string;
  dateType?: string;
}

export interface InventoryPortalPathType {
  id?: string;
  path?: string;
}

export interface InventoryCategoryTreeType {
  id?: string;
  name?: string;
  assetType?: string;
  expanded?: boolean;
  children?: InventoryCategoryTreeType[];
  hasChildren?: boolean;
}

export interface CategoriesType {
  inventoryCategory?: string;
  inventoryCategoryTree?: InventoryCategoryTreeType;
  inventoryPortalPath?: InventoryPortalPathType;
}

export interface InventoryDataItem {
  id?: string;
  externalId?: string;
  assetType?: string;
  updatedDate?: number;
  [key: string]: string | number;
}

export interface InventoryType {
  categories: CategoriesType;
  data: InventoryDataItem[];
  columns: ColumnItem[];
  filters: Object;
  sort: Object;
}

export interface ElementGroupsTreeItem {
  id?: string;
  name?: string;
  elements?: InventoryAssetTreeStateType[];
}

export interface InventoryAssetTreeStateType {
  id?: string;
  name?: string;
  assetType?: string;
  markerId?: number;
  elementGroups?: ElementGroupsTreeItem[];
  elements?: InventoryAssetTreeStateType[];
  changeType?: string;
  attributeGroups?: AttributeGroupsItem[];
  attributes?: AttributesCollection;
}

export enum InventoryPortalView {
  LIST = 'LIST',
  MAP = 'MAP',
}
